/**
 *
 * @module entry
 * @desc {SDK.UserActivity.Personalization} entry point.
 *
 */

import PersonalizationEvent from './personalizationEvent';
import PersonalizationEvents from './personalizationEvents';
import UserActivityAction from './userActivityAction';


/**
 *
 * @typedef SDK.UserActivity.Personalization
 * @type {Object}
 *
 * @property {PersonalizationEvent} PersonalizationEvent
 * @property {PersonalizationEvents} PersonalizationEvents
 * @property {UserActivityAction} UserActivityAction
 *
 */

/**
 *
 * @type {SDK.UserActivity.Personalization}
 *
 */
export default {

    PersonalizationEvent,
    PersonalizationEvents,
    UserActivityAction

};



// WEBPACK FOOTER //
// ./src/userActivity/personalization/entry.js